import * as api from '../../../../api';

export const loadGroups = async companyId => {
    const { data } = await api.get(
        `/api/organization/${companyId}/partner/company_groups`
    );
    return data;
};

export const loadGroup = async (id, companyId) => {
    const { data } = await api.get(
        `/api/organization/${companyId}/partner/company_groups/${id}`
    );
    return data;
};

export const removeGroups = async (groups, companyId) => {
    const uuids = groups.map(group => ({ uuid: group.uuid }));
    await api.remove(
        `/api/organization/${companyId}/partner/company_groups`,
        uuids
    );
};

export const createGroup = async (data, companyId) => {
    const { group } = await api.post(
        `/api/organization/${companyId}/partner/company_groups`,
        data
    );
    return group;
};

export const updateGroup = async (id, data, companyId) => {
    data.uuid = id;
    const { group } = await api.patch(
        `/api/organization/${companyId}/partner/company_groups`,
        data
    );
    return group;
};

export const loadCompanies = async companyId => {
    const { data } = await api.get(
        `/api/organization/${companyId}/partner/company_groups/companies`
    );
    return data;
};

export const loadCompany = async companyId => {
    const { data } = await api.get(`/api/organizations/${companyId}`);
    return data[0];
};
